/** Shared status chip for the Labour Management demo screen - maps a status/coverage value
 * to a colour-coded MUI Chip. Extracted since the same status-to-colour mapping is reused
 * across KPI cards, risk cards, coverage table, rota table and readiness panel. */

import { Chip } from '@mui/material';
import { CoverageStatus, LabourStatus } from '../types';

const STATUS_COLOR: Record<LabourStatus, 'success' | 'warning' | 'error'> = {
  good: 'success',
  warning: 'warning',
  critical: 'error',
};

const COVERAGE_STATUS_MAP: Record<CoverageStatus, LabourStatus> = {
  Covered: 'good',
  Tight: 'warning',
  Understaffed: 'critical',
  Overstaffed: 'warning',
};

interface StatusChipProps {
  status: LabourStatus;
  label: string;
}

export const StatusChip = ({ status, label }: StatusChipProps) => (
  <Chip label={label}
    color={STATUS_COLOR[status]}
    size="small"
    variant="outlined" />
);

interface CoverageChipProps {
  status: CoverageStatus;
}

export const CoverageChip = ({ status }: CoverageChipProps) => (
  <Chip label={status}
    color={STATUS_COLOR[COVERAGE_STATUS_MAP[status]]}
    size="small"
    variant="outlined" />
);

export const statusToColor = (status: LabourStatus) => STATUS_COLOR[status];
export const coverageToStatus = (status: CoverageStatus) => COVERAGE_STATUS_MAP[status];
